import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalContent - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer ModalContent for easy migration
 */
const ModalContent = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-content'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      {children}
    </div>
  );
};

ModalContent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

ModalContent.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default ModalContent;
